import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import styled from 'styled-components/native';
import BottomSheet from '@/modals/BottomSheet';
import { getInputType, formatPlaceholder } from '@/types/b2bForm';
import Input from '@/screens/ChallengeDetailScreen/components/ChallengeDetailCompanyModal/Input';
import FormFieldOptionSelector from '@/components/molecules/FormFieldOptionSelector';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
/**
 * Dynamic form field renderer component
 *
 * Renders either a text input or select input based on field.options:
 * - options === null → Text input (주관식)
 * - options === array → Select input with BottomSheet (객관식)
 *
 * Uses existing Input and FormFieldOptionSelector components for consistency.
 */
export default function FormFieldRenderer({ field, value, onChange, elementNamePrefix: _elementNamePrefix = 'form-field', }) {
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const inputType = getInputType(field);
    const labelNode = (_jsxs(LabelWrapper, { children: [_jsx(LabelText, { children: field.displayName }), field.isRequired && _jsx(RequiredMark, { children: ' *' })] }));
    // Text input (주관식)
    if (inputType === 'text') {
        return (_jsxs(FieldContainer, { children: [labelNode, _jsx(Input, { value: value, onChangeText: onChange, placeholder: formatPlaceholder(field.displayName), returnKeyType: "next", isClearable: true })] }));
    }
    // Select input (객관식)
    return (_jsxs(FieldContainer, { children: [labelNode, _jsx(Input, { value: value, placeholder: formatPlaceholder(field.displayName), isClearable: false, onPress: () => setIsBottomSheetVisible(true) }), _jsx(BottomSheet, { isVisible: isBottomSheetVisible, onPressBackground: () => setIsBottomSheetVisible(false), children: _jsx(FormFieldOptionSelector, { title: field.displayName, value: value, onChange: onChange, onClose: () => setIsBottomSheetVisible(false), options: field.options }) })] }));
}
const FieldContainer = styled.View `
  gap: 8px;
`;
const LabelWrapper = styled.View `
  flex-direction: row;
  align-items: center;
`;
const LabelText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 13px;
  color: ${color.black};
`;
const RequiredMark = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 13px;
  color: ${color.red};
`;
